<template>
  <thead>
    <slot />
    <tr v-if="isVisible">
      <th colspan="7">
        <Comment
          :entity="entity"
          :style="{ marginBottom: '0' }"
        />
      </th>
    </tr>
  </thead>
</template>

<script>
import { inject } from 'vue'

import Comment from './Comment'

export default {
  name: 'CustomHeaderWrapper',
  components: {
    Comment
  },
  props: {
    entity: {
      type: Object,
      required: true
    }
  },
  setup () {
    return {
      isVisible: inject('isVisible')
    }
  }
}
</script>
